import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Box,
  Stack,
  Dialog,
  DialogContent,
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormControlLabel,
  Radio,
  RadioGroup,
  Avatar,
} from "@mui/material";
import "../TaskAssignment/TaskAssignment.css";
import { farmers, images, taskAssign } from "../../config/images";
import Pagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "./DataCollector.css";
import { useNavigate } from "react-router-dom";
import { getDataCollectorList, signup } from "../../config/services";
import { toast } from "react-toastify";

const DataCollector = () => {
  const [addCollectoer, setAddCollector] = useState(false);

  const [tasks, setTasks] = useState([]);
  const [formValues, setTaskData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    mobileNumber: "",
    gender: "",
    email: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTaskData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [createLoading, setCreateLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);

  const notify = (message) => {
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const notifySuccess = (message) => {
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION_TOP_RIGHT,
      toastClassName: "custom-toast",
    });
  };

  const handleSwitchChange = (e) => {
    setTaskData((prev) => ({
      ...prev,
      notification: e.target.checked,
    }));
  };

  const handleSubmit = async () => {
    // Handle form submission

    if (!formValues.firstName) {
      notify("Please enter First name.");
      return;
    }
    if (!formValues.middleName) {
      notify("Please enter Middle name.");
      return;
    }
    if (!formValues.lastName) {
      notify("Please enter Last name.");
      return;
    }
    if (!formValues.gender) {
      notify("Please select Gender.");
      return;
    }
    if (!formValues.mobileNumber) {
      notify("Please enter Mobile number.");
      return;
    }
    if (!formValues.email) {
      notify("Please enter Email.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formValues.email)) {
      notify("Please enter a valid Email.");
      return;
    }
    if (!formValues.newPassword) {
      notify("Please enter Password");
      return;
    }
    if (!formValues.confirmPassword) {
      notify("Please Re enter password ");
      return;
    }
    if (formValues.newPassword != formValues.confirmPassword) {
      notify("Password and confirm password is not same.");
      return;
    }

    const formData = new FormData(); // ✅ Create FormData object

    formData.append("first_name", formValues.firstName);
    formData.append("middle_name", formValues.middleName);
    formData.append("last_name", formValues.lastName);
    formData.append("gender", formValues.gender === "male" ? 0 : 1);
    formData.append("role", 5);
    formData.append("mobile_number", `91${formValues.mobileNumber}`);
    formData.append("email", formValues.email);
    formData.append("password", formValues.password);

    try {
      setCreateLoading(true);

      const resp = await signup(formData);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setAddCollector(false);
        setTimeout(() => {
          setCreateLoading(false);
        }, 2000);
        fetchData();
      }
    } catch (error) {
      notify(error.response.data.message);
      setTimeout(() => {
        setCreateLoading(false);
      }, 2000);
    }
  };
  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));
  const navigate = useNavigate();
  const handleVisibilityClick = (id) => {
    navigate(`/collectorlist-detail/${id}`);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const resp = await getDataCollectorList({ currentPage, perPage });

      if (resp.data.results.success == true) {
        setTasks(resp.data.results.payload);

        // Calculate total pages
        setCount(resp.data.count);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage]);

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleTogglePasswordVisibility = (name) => {
    if (name === "newPassword") {
      setShowPassword((prevShowPassword) => !prevShowPassword);
    } else if (name === "confirmPassword") {
      setShowConfirmPassword(
        (prevShowConfirmPassword) => !prevShowConfirmPassword
      );
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box className="task-assign-box">
            <Box
              className="d-flex justify-content-between align-items-center"
              style={{ flexWrap: "wrap" }}
            >
              <Box
                className="d-flex  gap-3 img-box"
                style={{ padding: "25px" }}
              >
                <img src={taskAssign.collector} alt="" />
                <Typography variant="h6" gutterBottom>
                  Data Collectors
                </Typography>
              </Box>
              <Box className="collector-btn">
                <button
                  className="assign-task-btn"
                  onClick={() => setAddCollector(true)}
                >
                  Add Collectors
                </button>
              </Box>
            </Box>
            <Box style={{ width: "100%", overflowX: "auto" }}>
              <Table className="task-assign-table collector-table">
                <TableHead>
                  <TableRow>
                    <TableCell>Sr.No</TableCell>
                    <TableCell>Photo</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Gender</TableCell>
                    <TableCell>Mobile Number</TableCell>
                    <TableCell>Email</TableCell>

                    <TableCell>Status / View</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasks.map((task, index) => (
                    <TableRow key={index}>
                      {/* <TableCell>{index + 1}</TableCell> */}
                      <TableCell style={{ textAlign: "center" }}>
                        {index + 1 + (currentPage - 1) * perPage}
                      </TableCell>
                      <TableCell>
                        {" "}
                        {/* <img
                        src={task.profile_photo}
                        alt="Farmer"
                        className="farmer-photo"
                      /> */}
                        <Avatar
                          src={task.profile_photo}
                          alt="Farmer"
                          className="farmer-photo"
                        />
                      </TableCell>
                      <TableCell>
                        {task.first_name} {task.middle_name} {task.last_name}
                      </TableCell>
                      <TableCell>
                        {task.gender == 0 ? "Male" : "Female"}
                      </TableCell>
                      <TableCell>{task.mobile_number}</TableCell>

                      <TableCell>{task.email}</TableCell>
                      <TableCell>
                        <div className="d-flex gap-4">
                          <div
                            style={{
                              width: "50px",
                              color: task.is_active == true ? "#31A05F" : "",
                            }}
                          >
                            {task.is_active == true ? "Active" : "Inactive"}
                          </div>
                          <VisibilityIcon
                            onClick={() => handleVisibilityClick(task.id)}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
            <Box display="flex" justifyContent="end" alignItems="center">
              <Stack spacing={2} className="mb-2">
                <CustomPagination
                  count={Math.ceil(count / perPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Stack>
            </Box>
            <Dialog
              open={addCollectoer}
              // onClose={() => setAddCollector(false)}
              maxWidth="xs"
              fullWidth
              disableScrollLock
              PaperProps={{
                sx: { borderRadius: "12px" },
              }}
            // className="dialog-assign"
            >
              <div className="assign-div">
                {" "}
                <div className="d-flex justify-content-around align-items-center">
                  <h5
                    className="p-3 mb-0"
                    style={{ textAlign: "center", marginLeft: "100px" }}
                  >
                    Add Collector
                  </h5>
                  <img
                    src={taskAssign.closeIcon}
                    alt=""
                    style={{
                      height: "30px",
                      width: "30px",
                      cursor: "pointer",
                      marginLeft: "65px",
                    }}
                    className="close-btn-model"
                    onClick={() => setAddCollector(false)}
                  />
                </div>
              </div>
              <DialogContent>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <OutlinedInput
                    value={formValues.firstName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow only letters and limit to 50 characters
                      if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                        handleChange(e);
                      }
                    }}
                    name="firstName"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.mobileNumberIcon}
                          alt="mobile-icon"
                          className="input-logo"
                        />
                      </InputAdornment>
                    }
                    placeholder="First Name"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <OutlinedInput
                    value={formValues.middleName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow only letters and limit to 50 characters
                      if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                        handleChange(e);
                      }
                    }}
                    name="middleName"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.mobileNumberIcon}
                          alt="mobile-icon"
                          className="input-logo"
                        />
                      </InputAdornment>
                    }
                    placeholder="Middle Name"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <OutlinedInput
                    value={formValues.lastName}
                    onChange={(e) => {
                      const inputValue = e.target.value;
                      // Allow only letters and limit to 50 characters
                      if (/^[A-Za-z\s]{0,50}$/.test(inputValue)) {
                        handleChange(e);
                      }
                    }}
                    name="lastName"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.mobileNumberIcon}
                          alt="mobile-icon"
                          className="input-logo"
                        />
                      </InputAdornment>
                    }
                    placeholder="Last Name"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <RadioGroup
                    row
                    className="login-type"
                    name="gender"
                    value={formValues.gender}
                    onChange={handleChange}
                  >
                    <div className="singIn-option-div">
                      <FormControlLabel
                        value="male"
                        control={<Radio />}
                        label="Male"
                      />
                    </div>
                    <div className="singIn-option-div">
                      <FormControlLabel
                        value="female"
                        control={<Radio />}
                        label="Female"
                      />
                    </div>
                  </RadioGroup>
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }}>
                  <OutlinedInput
                    value={formValues.mobileNumber}
                    onChange={handleChange}
                    name="mobileNumber"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 10,
                      pattern: "[0-9]*",
                      inputMode: "numeric",
                    }}
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.mobileIcon}
                          alt="mobile-icon"
                          className="input-logo"
                        />
                      </InputAdornment>
                    }
                    placeholder="Mobile Number"
                  />
                </FormControl>
                <FormControl
                  fullWidth
                  sx={{ m: 1 }}
                >
                  <OutlinedInput
                    value={formValues.email}
                    onChange={handleChange}
                    name="email"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.emailIcon}
                          alt="email-icon"
                          className="input-logo"
                        />
                      </InputAdornment>
                    }
                    placeholder="Email"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? "text" : "password"}
                    value={formValues.newPassword}
                    onChange={handleChange}
                    name="newPassword"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.viewPassword}
                          className="input-logo"
                          alt=""
                        ></img>
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.viewIcon}
                          onClick={() =>
                            handleTogglePasswordVisibility("newPassword")
                          }
                          className="input-logo"
                          style={{ cursor: "pointer" }}
                        ></img>
                      </InputAdornment>
                    }
                    placeholder="Password"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ m: 1 }} variant="outlined">
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={showconfirmPassword ? "text" : "password"}
                    value={formValues.confirmPassword}
                    onChange={handleChange}
                    name="confirmPassword"
                    startAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.viewPassword}
                          className="input-logo"
                          alt=""
                        ></img>
                      </InputAdornment>
                    }
                    endAdornment={
                      <InputAdornment position="start">
                        <img
                          src={images.viewIcon}
                          onClick={() =>
                            handleTogglePasswordVisibility("confirmPassword")
                          }
                          className="input-logo"
                          style={{ cursor: "pointer" }}
                        ></img>
                      </InputAdornment>
                    }
                    placeholder="Re-Enter Password"
                  />
                </FormControl>

                <button
                  className="assign-task-button mt-2"
                  onClick={handleSubmit}
                  disabled={createLoading}
                >
                  {createLoading ? (
                    <span className="spinner"></span>
                  ) : (
                    "Add Collector"
                  )}
                </button>
              </DialogContent>
            </Dialog>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default DataCollector;
